// extracted by mini-css-extract-plugin
export default {"screen-reader-text":"markdown_screen-reader-text__NTLc1"};